import {Typography} from '@mui/material';
import {Box} from '@mui/system';
import {useTranslation} from 'react-i18next';

import PoweredByModak from '@/app/shared-components/PoweredByModak/PoweredByModak';

import './styles';

interface IPaymentLinkV2FooterProps {
  isCampaign?: boolean;
}

const PaymentLinkV2Footer = ({isCampaign}: IPaymentLinkV2FooterProps) => {
  const {t} = useTranslation();

  return (
    <Box className="payment-link-v2-footer">
      <Box className="payment-link-v2-footer__badges">
        <PoweredByModak />
        <Box
          className="payment-link-v2-footer__divider"
          aria-hidden
        />
        <Box className="payment-link-v2-footer__security">
          <Box
            component="img"
            src="/assets/icons/secure-encrypt.svg"
            alt="secure encryption"
            className="payment-link-v2-footer__security-icon"
          />
          <Box className="payment-link-v2-footer__security-labels">
            <Typography className="payment-link-v2-footer__security-title">
              {t('payment_link.secure')}
            </Typography>
            <Typography className="payment-link-v2-footer__security-subtitle">
              {t('payment_link.tls_encryption')}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box className="payment-link-v2-footer__notes">
        <Typography className="payment-link-v2-footer__note">
          {t('payment_link_v2.fee_footer')}
        </Typography>
        <Typography className="payment-link-v2-footer__note">
          {t('payment_link_v2.tls_footer')}
        </Typography>
        {isCampaign && (
          <>
            <Typography className="payment-link-v2-footer__note">
              {t('payment_link_v2.fundraise_disclaimer_1')}
            </Typography>
            <Typography className="payment-link-v2-footer__note">
              {t('payment_link_v2.fundraise_disclaimer_2')}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
};

export default PaymentLinkV2Footer;
